import { useEffect, useState } from 'react';

const DURATION_SECONDS = 17 * 60 + 34;
const START = Date.now();

function remaining(): number {
  const elapsed = Math.floor((Date.now() - START) / 1000);
  return DURATION_SECONDS - (elapsed % DURATION_SECONDS);
}

export function useCountdown() {
  const [seconds, setSeconds] = useState<number>(remaining);

  useEffect(() => {
    const id = window.setInterval(() => setSeconds(remaining()), 1000);
    return () => window.clearInterval(id);
  }, []);

  return {
    hours: Math.floor(seconds / 3600),
    minutes: Math.floor((seconds % 3600) / 60),
    seconds: seconds % 60,
  };
}
